import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";

interface DocumentValI {
  documentLoading: boolean;
  setDocumentLoading: Dispatch<SetStateAction<boolean>>;
}

const Context = createContext<DocumentValI>({} as DocumentValI);

export default function DocumentLoadContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [documentLoading, setDocumentLoading] = useState(true);

  useEffect(() => {
    // callback function to call when event triggers
    const onPageLoad = () => {
      console.log("page loaded");
      setDocumentLoading(false);
    };

    // Check if the page has already loaded
    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad, false);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener("load", onPageLoad);
    }
  }, []);

  return (
    <Context.Provider value={{ documentLoading, setDocumentLoading }}>
      {children}
    </Context.Provider>
  );
}

export const useDocumentLoading = () => useContext(Context);
